
// NG 2
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';

// APP
@Component({
    selector: 'state-vav',
    templateUrl: './statenav.component.html'
})

export class StatenavComponent implements OnInit {
    userName: string = '';
    loginUser: any; 
    userFirstName: string; 

    constructor(private router: Router,
        private authenticationService: AuthenticationService) { }

    ngOnInit() {
        // Get Current User and set to User Name
        this.loginUser = this.authenticationService.getUser();
        if (this.loginUser != null) {
            this.userFirstName = this.userName = this.loginUser.FirstName;
            var tempName = this.userName.split(" ");
            if (tempName != null)
                this.userFirstName = tempName[0];  
        }
    }; 

    GoToApplication(evnet) {
        sessionStorage.removeItem('id');
        this.router.navigate(["/entity/addapplication"]);        
        event.stopPropagation();

    }
}